// // // src/contexts/AuthContext.js
// // import React, { createContext, useState, useContext } from 'react';

// // const AuthContext = createContext();

// // export const AuthProvider = ({ children }) => {
// //   const [isAuthenticated, setIsAuthenticated] = useState(false);

// //   const login = () => setIsAuthenticated(true);
// //   const logout = () => setIsAuthenticated(false);

// //   return (
// //     <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
// //       {children}
// //     </AuthContext.Provider>
// //   );
// // };

// // export const useAuth = () => useContext(AuthContext);


// // contexts/AuthContext.js
// import React, { createContext, useState, useEffect, useContext } from 'react';
// import { getToken, storeToken, removeToken } from '../utils/auth'; // Adjust path as needed

// const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);

//   useEffect(() => {
//     const checkAuth = async () => {
//       const token = await getToken();
      
//         console.log("checking token: ", token +", "+isAuthenticated);

//         if (token!=null) {
//             // Optionally validate token with your backend
//             setIsAuthenticated(true);
//             console.log("checking token inside if : ", token +", "+isAuthenticated);
//         }

        
//     };
//     checkAuth();
//   }, []);

//   useEffect(() => {
//     console.log("isAuthenticated changed: ",isAuthenticated);
//   }, [isAuthenticated]);

//   const login = async (token) => {
//     await storeToken(token);
//     setIsAuthenticated(true);
//   };

//   const logout = async () => {
//     await removeToken();
//     setIsAuthenticated(false);
//   };

//   return (
//     <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export const useAuth = () => useContext(AuthContext);


import React, { createContext, useState, useEffect, useContext } from 'react';
import { getToken, storeToken, removeToken } from '../utils/auth'; // Adjust path as needed


const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

    const [token, setToken] = useState(null);
    const [userId, setUserId] = useState(null);

    const storedToken = localStorage.getItem('authToken');
        const storedUserId = localStorage.getItem('userId');
        if (storedToken && storedUserId) {
            setToken(storedToken);
            setUserId(storedUserId);
        }

    useEffect(() => {
        const storedToken = localStorage.getItem('authToken');
        const storedUserId = localStorage.getItem('userId');
        if (storedToken && storedUserId) {
            setToken(storedToken);
            setUserId(storedUserId);
        }
    }, []);

    const login = async (token, userId) => {
        console.log("Login Done: ",token+", "+userId);
        localStorage.setItem('authToken', token);
        localStorage.setItem('userId', userId);
        setToken(token);
        setUserId(userId);
    };

    const logout = async () => {
        localStorage.removeItem('authToken');
        localStorage.removeItem('userId');
        setToken(null);
        setUserId(null);
    };

  return (
    <AuthContext.Provider value={{ token, userId, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
